import React from 'react';
import AdminDashboard from '../components/Admin/Dashboard/AdminDashboard';

const AdminDashboardPage = () => {
  return <AdminDashboard />;
};

export default AdminDashboardPage;
